/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Mid_Season_Text2Inputs */



/**
* | output |
* | --- |
* | "Thermostatic valves regulate the temperature of each room" |
*
* @param {Season_Mid_Season_Text2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_mid_season_text2 = /** @type {((inputs?: Season_Mid_Season_Text2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Mid_Season_Text2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermostatic valves regulate the temperature of each room")
	return /** @type {LocalizedString} */ ("Les têtes th. régulent la température de chaque pièce")
});